import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../Util/config';
import { DeviceSessionDTO, UpdateDeviceName } from '../Model/DeviceSession';
import { toast } from 'react-toastify';
import { createAuthBaseQuery } from '../Util/baseQuery';


const url = config.API.BASE_URL + config.API.ENDPOINTS.DEVICESESSION

export const deviceApi = createApi({
  reducerPath: 'deviceApi',
  baseQuery: createAuthBaseQuery(url),
  endpoints: (builder) => ({

    findAllDeviceSession: builder.query<DeviceSessionDTO[], string>({
      query: (id) => ({
        url: `findall/${id}`,
        method: 'GET',
      })
    }),
    broadcastUserUpdate: builder.mutation<void, string>({
      query: (id) => ({
        url: `broadcastUpdate/${id}`,
        method: 'PUT',
      }),
    }),
    broadcastPlaylistUpdate: builder.mutation<void, string>({
      query: (id) => ({
        url: `broadcastPlaylist/${id}`,
        method: 'PUT',
      }),
    }),
    updateName: builder.mutation<void, UpdateDeviceName>({
      query: (data) => ({
        url: "updateName",
        method: 'PUT',
        body: data
      }),
      onQueryStarted: async (dto, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch (error) {
          toast.error("Falha ao atualizar nome do dispositivo");
        }
      },
    }),
    deleteSession: builder.mutation<void, string>({
      query: (id) => ({
        url: `delete/${id}`,
        method: 'DELETE',
      }),
    }),
    forceUpdate: builder.mutation<void, string>({
      query: (id) => ({
        url: `forceUpdate/${id}`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useFindAllDeviceSessionQuery,
  useUpdateNameMutation,
  useLazyFindAllDeviceSessionQuery,
  useBroadcastUserUpdateMutation,
  useDeleteSessionMutation,
  useBroadcastPlaylistUpdateMutation,
  useForceUpdateMutation,
} = deviceApi;
